// Original decorative crop illustrations. IDs keep language and legacy aliases stable.
export const CROP_ILLUSTRATIONS = {
  "WCA-1": "abaca",
  "WCA-10": "arracacha",
  "WCA-100": "eggplant",
  "WCA-101": "endive",
  "WCA-102": "fennel",
  "WCA-103": "fenugreek",
  "WCA-104": "fig",
  "WCA-105": "hazelnut",
  "WCA-106": "fique",
  "WCA-107": "flax",
  "WCA-108": "flax",
  "WCA-109": "fonio",
  "WCA-11": "arrowroot",
  "WCA-110": "formio",
  "WCA-111": "garlic",
  "WCA-112": "green-garlic",
  "WCA-113": "geranium",
  "WCA-114": "ginger",
  "WCA-115": "ginseng",
  "WCA-116": "gooseberry",
  "WCA-117": "gourd",
  "WCA-118": "chickpea",
  "WCA-119": "grape",
  "WCA-12": "artichoke",
  "WCA-120": "grapefruit",
  "WCA-121": "grape",
  "WCA-122": "grape",
  "WCA-123": "grape",
  "WCA-124": "esparto",
  "WCA-125": "orchard-grass",
  "WCA-126": "sudan-grass",
  "WCA-127": "peanut",
  "WCA-128": "guarana",
  "WCA-129": "guava",
  "WCA-13": "asparagus",
  "WCA-130": "sorghum",
  "WCA-131": "guinea-pepper",
  "WCA-132": "hazelnut",
  "WCA-133": "hemp",
  "WCA-134": "abaca",
  "WCA-135": "sunhemp",
  "WCA-136": "hemp",
  "WCA-137": "henequen",
  "WCA-138": "henna",
  "WCA-139": "hop",
  "WCA-14": "avocado",
  "WCA-140": "broad-bean",
  "WCA-141": "horseradish",
  "WCA-142": "maize",
  "WCA-143": "indigo",
  "WCA-144": "jasmine",
  "WCA-145": "jerusalem-artichoke",
  "WCA-146": "jojoba",
  "WCA-147": "sorghum",
  "WCA-148": "jute",
  "WCA-149": "kale",
  "WCA-15": "pearl-millet",
  "WCA-150": "kapok",
  "WCA-151": "kava",
  "WCA-152": "kenaf",
  "WCA-153": "kiwi",
  "WCA-154": "kohlrabi",
  "WCA-155": "kola",
  "WCA-156": "lavender",
  "WCA-157": "leek",
  "WCA-158": "lemon",
  "WCA-159": "lemongrass",
  "WCA-16": "bambara",
  "WCA-160": "lentil",
  "WCA-161": "lespedeza",
  "WCA-162": "lettuce",
  "WCA-163": "lime",
  "WCA-164": "lime",
  "WCA-165": "flax",
  "WCA-166": "liquorice",
  "WCA-167": "litchi",
  "WCA-168": "loquat",
  "WCA-169": "lupine",
  "WCA-17": "banana",
  "WCA-170": "macadamia",
  "WCA-171": "mace",
  "WCA-172": "maguey",
  "WCA-173": "maize",
  "WCA-174": "maize",
  "WCA-175": "maize",
  "WCA-176": "maize",
  "WCA-177": "mandarin",
  "WCA-178": "beet-fodder",
  "WCA-179": "mango",
  "WCA-18": "barley",
  "WCA-180": "mangosteen",
  "WCA-181": "cassava",
  "WCA-182": "mixed-cereals",
  "WCA-183": "medlar",
  "WCA-184": "melon",
  "WCA-185": "broom-millet",
  "WCA-186": "pearl-millet",
  "WCA-187": "pearl-millet",
  "WCA-188": "finger-millet",
  "WCA-189": "foxtail-millet",
  "WCA-19": "bay",
  "WCA-190": "japanese-millet",
  "WCA-191": "pearl-millet",
  "WCA-192": "proso-millet",
  "WCA-193": "mint",
  "WCA-194": "mulberry",
  "WCA-195": "mulberry",
  "WCA-196": "mushroom",
  "WCA-197": "mustard",
  "WCA-198": "nectarine",
  "WCA-199": "formio",
  "WCA-2": "alfalfa",
  "WCA-20": "basil",
  "WCA-200": "niger",
  "WCA-201": "nutmeg",
  "WCA-202": "oats",
  "WCA-203": "oats",
  "WCA-204": "oil-palm",
  "WCA-205": "okra",
  "WCA-206": "olive",
  "WCA-207": "onion-seed",
  "WCA-208": "onion",
  "WCA-209": "green-onion",
  "WCA-21": "beans-dry",
  "WCA-210": "poppy",
  "WCA-211": "orange",
  "WCA-212": "orange",
  "WCA-213": "ornamental",
  "WCA-214": "palmyra",
  "WCA-215": "oil-palm",
  "WCA-216": "oil-palm",
  "WCA-217": "sago-palm",
  "WCA-218": "papaya",
  "WCA-219": "parsnip",
  "WCA-22": "beans",
  "WCA-220": "peas-dry",
  "WCA-221": "peas",
  "WCA-222": "peach",
  "WCA-223": "peanut",
  "WCA-224": "pear",
  "WCA-225": "pecan",
  "WCA-226": "black-pepper",
  "WCA-227": "pepper-dry",
  "WCA-228": "persimmon",
  "WCA-229": "pigeon-pea",
  "WCA-23": "beet-fodder",
  "WCA-230": "pineapple",
  "WCA-231": "pistachio",
  "WCA-232": "plantain",
  "WCA-233": "plum",
  "WCA-234": "pomegranate",
  "WCA-235": "pomelo",
  "WCA-236": "poppy",
  "WCA-237": "poppy",
  "WCA-238": "potato",
  "WCA-239": "sweet-potato",
  "WCA-24": "beet-red",
  "WCA-240": "prune",
  "WCA-241": "pumpkin",
  "WCA-242": "pumpkin",
  "WCA-243": "pyrethrum",
  "WCA-244": "macadamia",
  "WCA-245": "quince",
  "WCA-246": "quinine",
  "WCA-247": "quinoa",
  "WCA-248": "radish",
  "WCA-249": "ramie",
  "WCA-25": "beet-sugar",
  "WCA-250": "rapeseed",
  "WCA-251": "raspberry",
  "WCA-252": "beet-red",
  "WCA-253": "redtop",
  "WCA-254": "ramie",
  "WCA-255": "rhubarb",
  "WCA-256": "rice",
  "WCA-257": "rose",
  "WCA-258": "rubber",
  "WCA-259": "rutabaga",
  "WCA-26": "beet-sugar",
  "WCA-260": "rye",
  "WCA-261": "ryegrass",
  "WCA-262": "safflower",
  "WCA-263": "saffron",
  "WCA-264": "sainfoin",
  "WCA-265": "salsify",
  "WCA-266": "sapodilla",
  "WCA-267": "mandarin",
  "WCA-268": "scorzonera",
  "WCA-269": "sesame",
  "WCA-27": "beet-sugar",
  "WCA-270": "shea",
  "WCA-271": "sisal",
  "WCA-272": "sorghum",
  "WCA-273": "broom-sorghum",
  "WCA-274": "sorghum",
  "WCA-275": "sorghum",
  "WCA-276": "sorghum",
  "WCA-277": "sorghum",
  "WCA-278": "sour-cherry",
  "WCA-279": "soybean",
  "WCA-28": "bergamot",
  "WCA-280": "soybean",
  "WCA-281": "spelt",
  "WCA-282": "spinach",
  "WCA-283": "squash",
  "WCA-284": "strawberry",
  "WCA-285": "beet-sugar",
  "WCA-286": "beet-sugar",
  "WCA-287": "beet-sugar",
  "WCA-288": "sugar-cane",
  "WCA-289": "sugar-cane",
  "WCA-29": "areca",
  "WCA-290": "sugar-cane",
  "WCA-291": "sunflower",
  "WCA-292": "sunflower",
  "WCA-293": "sunhemp",
  "WCA-294": "rutabaga",
  "WCA-295": "rutabaga",
  "WCA-296": "maize",
  "WCA-297": "lime",
  "WCA-298": "sweet-pepper",
  "WCA-299": "sweet-potato",
  "WCA-3": "alfalfa",
  "WCA-30": "black-pepper",
  "WCA-300": "sorghum",
  "WCA-301": "tallow",
  "WCA-302": "mandarin",
  "WCA-303": "tannia",
  "WCA-304": "cassava",
  "WCA-305": "taro",
  "WCA-306": "tea",
  "WCA-307": "teff",
  "WCA-308": "thyme",
  "WCA-309": "timothy",
  "WCA-31": "blackberry",
  "WCA-310": "tobacco",
  "WCA-311": "tomato",
  "WCA-312": "trefoil",
  "WCA-313": "triticale",
  "WCA-314": "tung",
  "WCA-315": "turmeric",
  "WCA-316": "turnip",
  "WCA-317": "turnip",
  "WCA-318": "urena",
  "WCA-319": "vanilla",
  "WCA-32": "blueberry",
  "WCA-320": "vetch",
  "WCA-321": "walnut",
  "WCA-322": "watermelon",
  "WCA-323": "wheat",
  "WCA-324": "yam",
  "WCA-325": "tannia",
  "WCA-326": "yerba-mate",
  "WCA-33": "brazil-nut",
  "WCA-34": "breadfruit",
  "WCA-35": "broad-bean",
  "WCA-36": "broad-bean",
  "WCA-37": "broccoli",
  "WCA-38": "broom-millet",
  "WCA-39": "broom-sorghum",
  "WCA-4": "almond",
  "WCA-40": "brussels-sprouts",
  "WCA-41": "buckwheat",
  "WCA-42": "cabbage",
  "WCA-43": "chinese-cabbage",
  "WCA-44": "cabbage",
  "WCA-45": "cacao",
  "WCA-46": "cantaloupe",
  "WCA-47": "caraway",
  "WCA-48": "cardamom",
  "WCA-49": "cardoon",
  "WCA-5": "angelica",
  "WCA-50": "carob",
  "WCA-51": "carrot",
  "WCA-52": "carrot",
  "WCA-53": "cashew",
  "WCA-54": "cassava",
  "WCA-55": "castor",
  "WCA-56": "cauliflower",
  "WCA-57": "celeriac",
  "WCA-58": "celery",
  "WCA-59": "chayote",
  "WCA-6": "anise",
  "WCA-60": "cherry",
  "WCA-61": "chestnut",
  "WCA-62": "chickpea",
  "WCA-63": "chicory",
  "WCA-64": "chili",
  "WCA-65": "chili",
  "WCA-66": "cinnamon",
  "WCA-67": "citron",
  "WCA-68": "citronella",
  "WCA-69": "mandarin",
  "WCA-7": "apple",
  "WCA-70": "clove",
  "WCA-71": "clover",
  "WCA-72": "coca",
  "WCA-73": "cacao",
  "WCA-74": "coconut",
  "WCA-75": "taro",
  "WCA-76": "coffee",
  "WCA-77": "kola",
  "WCA-78": "rapeseed",
  "WCA-79": "maize",
  "WCA-8": "apricot",
  "WCA-80": "maize",
  "WCA-81": "maize",
  "WCA-82": "corn-salad",
  "WCA-83": "cotton",
  "WCA-84": "cotton",
  "WCA-85": "cowpea",
  "WCA-86": "cowpea",
  "WCA-87": "cranberry",
  "WCA-88": "cress",
  "WCA-89": "cucumber",
  "WCA-9": "areca",
  "WCA-90": "currant",
  "WCA-91": "custard-apple",
  "WCA-92": "taro",
  "WCA-93": "date",
  "WCA-94": "dill",
  "WCA-95": "moringa",
  "WCA-96": "sorghum",
  "WCA-97": "durum-wheat",
  "WCA-98": "bambara",
  "WCA-99": "taro"
};
export function cropIllustration(crop) {
 const name = [crop.crop_id, ...(crop.merged_ids || [])].map(id => CROP_ILLUSTRATIONS[id]).find(Boolean);
 return name ? `/crops/${name}.svg` : `/fao/${crop.icc_code?.split(".")[0] || "9"}.svg`;
}
